import { render, staticRenderFns } from "./CreateSurveyTemplate.vue?vue&type=template&id=e9631132"
import script from "./CreateSurveyTemplate.vue?vue&type=script&lang=js"
export * from "./CreateSurveyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports